var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconRocket = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 16,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.831 11.655a5.966 5.966 0 0 1 6.96-9.6M1.74 11.613C.98 12.94.727 13.97 1.155 14.4c.65.65 2.684-.269 5.039-2.136m2.695-.472L6.652 9.554m2.237 2.238 4.973-4.974c.406-.405.693-.913.832-1.47l.32-1.28a.527.527 0 0 0-.639-.64l-1.28.322a3.16 3.16 0 0 0-1.47.831L6.652 9.554m2.237 2.238.611 1.833a.263.263 0 0 0 .437.103l.64-.639a2.11 2.11 0 0 0 .51-2.163l-.333-1zM6.652 9.554l-1.833-.61a.264.264 0 0 1-.103-.438l.639-.639a2.11 2.11 0 0 1 2.164-.51l1 .332z"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 16,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: fill,
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.831 11.655a5.966 5.966 0 0 1 6.96-9.6M1.74 11.613C.98 12.94.727 13.97 1.155 14.4c.65.65 2.684-.269 5.039-2.136m2.695-.472L6.652 9.554m2.237 2.238 4.973-4.974c.406-.405.693-.913.832-1.47l.32-1.28a.527.527 0 0 0-.639-.64l-1.28.322a3.16 3.16 0 0 0-1.47.831L6.652 9.554m2.237 2.238.611 1.833a.263.263 0 0 0 .437.103l.64-.639a2.11 2.11 0 0 0 .51-2.163l-.333-1zM6.652 9.554l-1.833-.61a.264.264 0 0 1-.103-.438l.639-.639a2.11 2.11 0 0 1 2.164-.51l1 .332z"
  }));
});
export default SvgIconRocket;
export const raw = __webpack_public_path__ + "static/media/IconRocket.ce5928d3fa59ce415072e1c69119ccff.svg";